import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import barReducer from './bar/data/reducer';
import barSaga from './bar/data/sagas';
import materialWidgetReducer from './data/reducer';
import materialWidgetSaga from './data/sagas';
import rodReducer from './rod/data/reducer';
import rodSaga from './rod/data/sagas';
import sheetReducer from './sheet/data/reducer';
import sheetSaga from './sheet/data/sagas';

export const reducer = combineReducers({
  bar: barReducer,
  materialWidget: materialWidgetReducer,
  rod: rodReducer,
  sheet: sheetReducer,
});

export const saga = function* () {
  yield all([barSaga(), materialWidgetSaga(), rodSaga(), sheetSaga()]);
};
